<template>
  <div class="wechatauth">
    <div class="loading-box">
      <div class="spin"></div>
      <p>{{ tip }}</p>
    </div>
  </div>
</template>

<script>
import { wechatLoginApi } from '@/api/login'
import { Toast } from 'vant'

export default {
  name: 'WechatAuth',
  data () {
    return {
      tip: '微信登录中，请稍候...'
    }
  },
  created () {
    this.handleWechatLogin()
  },
  methods: {
    // 解析 state：后端把回跳地址 hex 编码在 state 中（state = hex(redirect) . 签名）
    parseRedirect (state) {
      if (!state) return '/home'
      const dot = state.indexOf('.')
      if (dot <= 0) return '/home'
      const hex = state.slice(0, dot)
      // hex 长度必须为偶数，避免非法输入
      if (hex.length % 2 !== 0) return '/home'
      let redirect = ''
      try {
        for (let i = 0; i < hex.length; i += 2) {
          redirect += String.fromCharCode(parseInt(hex.substr(i, 2), 16))
        }
      } catch (e) {
        return '/home'
      }
      // 只允许站内路径
      return (redirect && redirect.indexOf('/') === 0) ? redirect : '/home'
    },
    // 解析 window.location.search（# 之前的 query），兼容微信把 code 加在 hash 之前的情况
    parseLocationQuery () {
      const params = {}
      const search = window.location.search || ''
      const query = search.charAt(0) === '?' ? search.slice(1) : search
      if (!query) return params
      query.split('&').forEach(pair => {
        if (!pair) return
        const idx = pair.indexOf('=')
        let key = pair
        let val = ''
        if (idx > -1) {
          key = pair.slice(0, idx)
          val = pair.slice(idx + 1)
        }
        try {
          key = decodeURIComponent(key)
          val = decodeURIComponent(val)
        } catch (e) {}
        params[key] = val
      })
      return params
    },
    // 兜底：从完整 URL 中按 name 提取参数（覆盖参数出现在任意位置的情况）
    matchHrefParam (name) {
      const m = window.location.href.match(new RegExp('[?&#]' + name + '=([^&#]+)'))
      if (m && m[1]) {
        try {
          return decodeURIComponent(m[1])
        } catch (e) {
          return m[1]
        }
      }
      return ''
    },
    async handleWechatLogin () {
      // 已登录用户进入回调页（如回退/刷新残留 URL），直接回首页，避免覆盖当前登录态
      if (this.$store.getters.token) {
        this.$router.replace('/home')
        return
      }
      // 微信回调参数可能出现的形态（本项目已切换 history 路由，两种都兼容）：
      //  1) 标准形态（history 路由）：  /wechatauth?code=xxx&state=xxx
      //  2) 旧版 hash 形态（历史链接）： /#/wechatauth?code=xxx&state=xxx
      // 因此同时从 Vue Router query、window.location.search、完整 URL 中提取
      const routeQuery = this.$route.query
      const locationQuery = this.parseLocationQuery()
      const code = routeQuery.code || locationQuery.code || this.matchHrefParam('code') || ''
      const state = routeQuery.state || locationQuery.state || this.matchHrefParam('state') || ''
      // 用户取消授权或授权失败时，微信会回跳但可能不带 code
      if (!code) {
        Toast('您已取消微信授权，请使用账号密码登录')
        this.gotoLogin()
        return
      }
      try {
        const { data } = await wechatLoginApi(code, state)
        // 将用户信息保存到 vuex 中（含 token）
        this.$store.commit('user/setUserInfo', data)
        Toast('微信登录成功')
        const redirect = this.parseRedirect(state)
        setTimeout(() => {
          this.goTo(redirect)
        }, 600)
      } catch (err) {
        // 显示具体错误信息，便于定位问题
        const msg = typeof err === 'string' ? err : (err && err.message) || '微信登录失败，请稍后重试'
        console.error('[wechatauth] 微信登录失败，当前URL：', window.location.href, '错误：', err)
        Toast(msg)
        setTimeout(() => {
          this.gotoLogin()
        }, 1200)
      }
    },
    // 登录成功后跳转，并清理 /wechatauth?code=xxx 这类临时参数，保持 URL 干净
    goTo (path) {
      if (window.location.search || window.location.hash) {
        window.location.replace(path)
      } else {
        this.$router.replace(path)
      }
    },
    gotoLogin () {
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="less" scoped>
.wechatauth {
  min-height: 100vh;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  .loading-box {
    text-align: center;

    .spin {
      width: 36px;
      height: 36px;
      margin: 0 auto;
      border: 3px solid #ececec;
      border-top-color: #07c160;
      border-radius: 50%;
      animation: rotate 0.8s linear infinite;
    }

    p {
      margin-top: 16px;
      font-size: 14px;
      color: #b8b8b8;
    }
  }
}

@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}
</style>
